<template>
    <div class="flex sm:flex-col md:flex-row  items-center h-32 justify-center  bg-gray-300 ">
         <div> </div>
         <div class="mx-auto text-white text-3xl font-extrabold"> </div> 
         <div > </div> 
    </div>
</template>

<script>
export default {
    
}
</script>

